import React from 'react'
import { useTranslation } from 'react-i18next';
import ManageState from './manageState';
import TableCustom from '../../../components/table/tableCustom';
import { debouncedApiCall } from '../../../utils/app.utils';
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
import StateComponents from '../../../components/state-component/StateComponents';
import { useNavigate } from 'react-router-dom';
import { routeName } from '../../../routes/routeName';
import ModalCustom from '../../../components/modal/ModalCustom';

export default function VisaIntendant() {
    const { t } = useTranslation();
    const {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,

        id_course_of_study,
        set_id_course_of_study,
        showModal,
        handleCloseModal,
        form,
        set_form,
        handleSubmitForm,
        setShowModal,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,
        dataEmployee,
        courseOfStudy,
        checkPermit
    } = ManageState()
    const navigate = useNavigate()

    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("จัดการผู้ดูแลหลักสูตร")}

                content={
                    <div className='w-full'>

                        <StateComponents
                            otherProps={{ spacing: 2 }}
                            typeProps={[
                                // {
                                //     seq: 1,
                                //     type: "SELECT",
                                //     gridProps: {
                                //         xs: 12,
                                //         md: 4
                                //     },
                                //     fieldProps: {
                                //         labelId: "ss",
                                //         heading: "",
                                //         onChange: (e) => {
                                //             // handleChange('form_type', index, e.target.value);
                                //             // set_id_degree(e.target.value)
                                //         },
                                //         options: [{
                                //             label: t('LIST_APPLICANTS_ALL_LEVELS'),
                                //             value: "ALL",
                                //         },
                                //             // ...degree?.map((item: any) => {
                                //             //     return {
                                //             //         label: item?.degree_name,
                                //             //         value: item?.id_degree,
                                //             //     }
                                //             // })
                                //         ],
                                //         selectId: "",
                                //         value: '',
                                //     }
                                // },
                                {
                                    seq: 1,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 4
                                    },
                                    fieldProps: {
                                        placeholder: "ค้นหา",
                                        onChange: (e) => debouncedApiCall({ setItem: setKeyword, searchItem: e.target.value })
                                    }
                                },
                                {
                                    seq: 2,
                                    type: "DATE_RANGE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        onchange: handleChangeDateRange,
                                        value: date_range || [],
                                        onClear: handleClearDateRange,
                                        allowClear: true,
                                        placeholder: t("LIST_APPLICANTS_DATE_RANGE")
                                    }
                                },
                                {
                                    seq: 3,
                                    type: "SELECT",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        labelId: "ss",
                                        heading: "",
                                        onChange: (e) => {
                                            // handleChange('form_type', index, e.target.value);
                                            set_id_course_of_study(e.target.value)
                                        },
                                        options: [{
                                            label: t('ทั้งหมด'),
                                            value: "ALL",
                                        },
                                        ...courseOfStudy?.map((item: any) => {
                                            return {
                                                label: `${item?.degree_name} ${item?.faculty_name}`,
                                                value: item?.id_course_of_study,
                                            }
                                        })
                                        ],
                                        selectId: "",
                                        value: id_course_of_study || '',
                                    }
                                },


                                {
                                    seq: 4,
                                    type: "BUTTON",
                                    gridProps: {
                                        xs: 6,
                                        md: 2
                                    },
                                    hidden: !checkPermit?.isCreated,
                                    fieldProps: {
                                        justifyContent: "flex-end",
                                        buttonData: [
                                            {
                                                seq: 1,
                                                key: "ADD2",
                                                label: t("เพิ่มผู้ดูแลหลักสูตร"),
                                                buttonProps: {
                                                    onClick: () => {
                                                        setShowModal("ADD")
                                                    },
                                                },
                                                type: "ADD2"
                                            }
                                        ]
                                    }
                                }
                            ]}
                        />

                        <section className='w-full mt-4'>
                            <TableCustom
                                tableMinWidth={1440}
                                tableFixedWidth
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy={sortBy}
                                sortType={sortType}
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={data?.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={handleRequestSort}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        </section>
                    </div>
                }
            />
            {showModal !== '' && (
                <ModalCustom
                    open
                    title={showModal === 'ADD' ? t("เพิ่มผู้ดูแลหลักสูตร") : t("ข้อมูลผู้ดูแลหลักสูตร")}
                    subTitle={t("กรุณาระบุข้อมูลให้ครบถ้วนก่อนการยืนยัน")}
                    onClose={handleCloseModal}
                    containerButton={{
                        disabled_submit: !form.id_employee || !form?.id_course_of_study || !form?.intendant_type,
                        hidden_submit: showModal === 'VIEW',
                        onClose: handleCloseModal,
                        onSubmit: () => handleSubmitForm()
                    }}
                    component={
                        <div className='w-full'>

                            <StateComponents
                                disabledAllField={showModal === 'VIEW'}
                                otherProps={{ spacing: 2 }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "AUTO-COMPLETE",
                                        gridProps: {
                                            xs: 12,
                                        },
                                        fieldProps: {
                                            getOptionLabel: (op: any) => op?.fullname,
                                            labelId: "select_position",
                                            placeholder: "ค้นหา ชื่อ-นามสกุล",
                                            heading: "ค้นหา ชื่อ-นามสกุล",
                                            onChange: (_: any, value: any) => {

                                                set_form((prev: any) => ({ ...prev, ...value }))
                                            },
                                            options: dataEmployee || [],
                                            value: form || null
                                        }
                                    },
                                    {
                                        seq: 2,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            heading: t("ตำแหน่ง"),
                                            disabled: true,
                                            value: form?.roles_name || form?.roles?.roles_name,
                                            onChange: (e) => { }
                                        }
                                    },
                                    {
                                        seq: 3,
                                        type: "AUTO-COMPLETE",
                                        gridProps: {
                                            xs: 12,
                                        },
                                        fieldProps: {
                                            getOptionLabel: (op: any) => op?.degree_name ? `${op?.degree_name} ${op?.faculty_name}` : '',
                                            labelId: "select_position",
                                            placeholder: "หลักสูตรที่ดูแล",
                                            heading: "หลักสูตรที่ดูแล",
                                            onChange: (_: any, value: any) => {

                                                set_form((prev: any) => ({ ...prev, ...value }))
                                            },
                                            options: courseOfStudy || [],
                                            value: form || null
                                        }
                                    },
                                    {
                                        seq: 4,
                                        type: "SELECT",
                                        gridProps: {
                                            xs: 12,
                                        },
                                        fieldProps: {
                                            labelId: "ss",
                                            heading: "ประเภทผู้ดูแลหลักสูตร",
                                            onChange: (e) => {
                                                // handleChange('form_type', index, e.target.value);
                                                set_form((prev: any) => ({ ...prev, intendant_type: e.target.value }))
                                            },
                                            options: [
                                                {
                                                    label: 'Visa',
                                                    value: "VISA",
                                                },
                                                {
                                                    label: 'Adminssion',
                                                    value: "ADMISSION",
                                                },
                                            ],
                                            selectId: "",
                                            value: form?.intendant_type || '',
                                        }
                                    },
                                ]}
                            />
                        </div>
                    }
                />
            )}
        </div>
    )
}
